import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Loader2 } from "lucide-react";
import { login } from "@/lib/api";

const inputBase =
  "w-full bg-transparent border border-[#C9C3B4] text-[#0F172A] placeholder:text-[#9B9689] px-4 py-3.5 rounded-none focus:outline-none focus:border-[#0055FF] transition-colors duration-300 font-body text-sm";

export const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email.trim(), password);
      toast.success("Welcome back.");
      onSuccess(user);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen bg-[#F5F1EA] blueprint-grid flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <Link
          to="/"
          data-testid="login-back"
          className="inline-flex items-center gap-2 font-mono-tech text-[11px] uppercase tracking-widest text-[#55524B] hover:text-[#0F172A] mb-8"
        >
          <ArrowLeft className="h-4 w-4" /> Back to site
        </Link>

        <div className="border border-[#C9C3B4] bg-[#FFFFFF]/80 backdrop-blur-xl p-8 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <img src="/logo/tavas-mark.png" alt="Tavas" className="h-11 w-auto" />
            <div>
              <span className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[#0055FF] block">
                Internal
              </span>
              <h1 className="font-display font-800 tracking-tighter text-xl leading-none mt-1 text-[#0F172A]">
                Admin Access
              </h1>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="font-mono-tech text-[10px] uppercase tracking-widest text-[#55524B] mb-2 block">
                Email
              </label>
              <input
                data-testid="login-email"
                type="email"
                className={inputBase}
                placeholder="you@tavasinfra.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
              />
            </div>
            <div>
              <label className="font-mono-tech text-[10px] uppercase tracking-widest text-[#55524B] mb-2 block">
                Password
              </label>
              <input
                data-testid="login-password"
                type="password"
                className={inputBase}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              data-testid="login-submit"
              disabled={loading}
              className="btn-industrial w-full inline-flex items-center justify-center gap-3 bg-[#0055FF] hover:bg-[#3377FF] disabled:opacity-60 text-white px-8 py-4 font-mono-tech text-xs uppercase tracking-widest"
            >
              {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in</> : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
